export const CustomPatternValidator = {
  email: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$',
  phone: '^\\s*(0(7|6)[0-9]{8}$)',
  phone1: '[0-9]{10}$',
  phone2: '[0][6-7]{1}[0-9]{8}$',
  postalCode: '^(([0-8][0-9])|(9[0-5]))[0-9]{3}$',
  name: '^[\\w\'\\-,.а-яА-Я][^0-9_!¡?÷?¿/\\\\+=@#$%ˆ&*(){}|~<>;:[\\]]{1,}$'
};
